<template>
  <div class="offer">
    <div class="row">
      <div class="col-12 col-lg-8">
        <div class="offer-title">
          <div class="address-h1">{{ presentationName }}</div>
        </div>
      </div>
      <div class="col-12 col-lg-4">
        <Price
          :lead="lead"
          :config="config"
          :currency="currency"
          :version="version"
          :hidingConfig="renderParams.hidingFieldsConfig"
          :currencyDict="renderParams.currencyDict"
        />
      </div>
    </div>

    <Images
      :lead="lead"
      :config="config"
      :version="version"
      :agent="renderParams.agent"
    />

    <div
      v-if="isOptionsExist || config.isLeadId"
      class="params d-flex flex-column flex-sm-row"
    >
      <div v-if="config.isLeadId" class="parameter d-flex d-sm-block">
        <div
          class="description"
          v-text="localeService.getConstantTranslationByKey('lead-id')"
        />
        <div v-html="lead.id" class="digits"></div>
      </div>
      <div
        v-for="cf of optionFields"
        :key="cf.field_id"
        class="parameter d-flex d-sm-block"
      >
        <div
          class="description"
          v-text="localeService.getTranslatedParam(cf.field_name)"
        />
        <div v-html="cf.valueHtml" class="digits"></div>
      </div>
    </div>

    <hr class="middle-hr" />
    <div class="d-flex justify-content-between flex-column">
      <div class="content">
        <div v-html="d.description" v-for="d of descriptions" :key="d.id" />
        <div class="d-flex justify-content-end align-content-center mt-4">
          <div v-if="config.isFeedback && renderParams.agent">
            <div
              data-target="#feedbackDialog"
              data-toggle="modal"
              class="main-button"
              @click="
                $emit('showFeedback', {
                  leadId: lead.id,
                  leadName: lead.name,
                  shown: true,
                  domain: config.domain,
                })
              "
            >
              {{ signUpForViewing }}
            </div>
          </div>
        </div>
        <Maps
          :type="mapsType"
          :version="version"
          :isInfrastructure="config.isInfrastructure"
          :address="address"
          :leadId="lead.id"
          :yakey="renderParams.yakey"
          :longitude="longitude"
          :latitude="latitude"
          :localeService="localeService"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Price from '../../common/Price.vue'
import Images from '../../common/Images/Images.vue'
import Maps from '../../common/Maps.vue'
import Locale from '../../../../services/locale'
import Common from '../../../../services/common'

export default {
  name: 'Offer',
  props: {
    lead: Object,
    version: String,
    renderParams: Object,
    localeService: Locale,
  },
  components: {
    Price,
    Images,
    Maps,
  },
  computed: {
    isOptionsExist() {
      return this.lead.custom_fields_values && this.config.options.length
    },
    signUpForViewing() {
      return this.localeService.getConstantTranslationByKey(
        'sign-up-for-viewing',
      )
    },
    cfs() {
      return this.lead.custom_fields_values
    },
    address() {
      const addressField = this.cfs?.find(
        (cf) => cf.field_id === this.config.address,
      )
      return addressField ? addressField.values[0].value : ''
    },
    latitude() {
      const latitudeField = this.cfs?.find(
        (cf) => cf.field_id === this.config.latitude,
      )
      return latitudeField ? latitudeField.values[0].value : ''
    },
    longitude() {
      const longitudeField = this.cfs?.find(
        (cf) => cf.field_id === this.config.longitude,
      )
      return longitudeField ? longitudeField.values[0].value : ''
    },
    optionFields() {
      const cfs = this.cfs
      return (
        this.config.options
          ?.map((o) => {
            const field = cfs?.find((cf) => cf.field_id === o)
            const options = this.renderParams.optionsNames
            const option = options?.find((opt) => Number(opt.id) === Number(o))
            if (o === 1) {
              return {
                field_type: 'numeric',
                field_name: 'Комиссия',
                field_id: 1,
                values: [
                  {
                    value: this.lead.price,
                  },
                ],
              }
            }
            if (!field) {
              return (
                option?.type === 'checkbox' && Common.getDefaultField(option)
              )
            }
            return field
          })
          .filter(Boolean)
          .map((field) =>
            Common.getFormattedField({
              field,
              dateFormat: this.renderParams.date,
              fieldsConfig: this.renderParams.hidingFieldsConfig,
              currencyDict: this.renderParams.currencyDict,
              priceFrom: this.renderParams.config.priceFrom,
              priceFieldId: this.renderParams.config.price,
              currencySymbol: this.renderParams.currency.symbol_native,
              localeService: this.localeService,
            }),
          ) || []
      )
    },
    presentationName() {
      const presentationNameField = this.cfs?.find(
        (cf) => cf.field_id === this.config.presentationNameFieldId,
      )
      return presentationNameField?.values[0].value || this.lead.name
    },
    config() {
      return this.renderParams.config
    },
    currency() {
      return this.renderParams.currency
    },
    descriptions() {
      try {
        const textFields = this.config.text
        return textFields
          .map(({ id }, idx) => {
            const descriptionField = this.cfs?.find((cf) => cf.field_id === id)
            if (!descriptionField) return
            const rawDescription = descriptionField?.values[0].value
            const noDescription = idx === 0 ? 'Нет описания' : ''
            const description =
              rawDescription?.replaceAll('!n', '') || noDescription
            return { id, description }
          })
          .filter(Boolean)
      } catch (e) {
        console.error(e)
        return []
      }
    },
    mapsType() {
      return this.renderParams.config?.maps?.type || 'yandex'
    },
  },
}
</script>

<style scoped>
@media (min-width: 992px) {
  .digits {
    line-height: 1.625rem;
  }
}

.last-offer {
  padding-bottom: 0 !important;
}

.offer {
  padding-bottom: 200px;
}

.description {
  line-height: 1.2rem;
}
hr {
  background-color: #dee2e6;
}
</style>
